import React, { Suspense, useContext, useEffect, useRef, useState } from 'react';

/// React router dom
import { Routes, Route, Outlet, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useOktaAuth } from '@okta/okta-react';
import { toRelativeUrl } from '@okta/okta-auth-js';
/// Css
import './index.css';
import './chart.css';
import './step.css';

import Footer from './layouts/Footer';
import ScrollToTop from './layouts/ScrollToTop';
/// Dashboard
import Home from './components/Dashboard/Home';

/// Pages

import EmptyPage from './components/Dashboard/EmptyPage';
import Error400 from './pages/Error400';
import Error403 from './pages/Error403';
import Error404 from './pages/Error404';
import Error500 from './pages/Error500';
import Error503 from './pages/Error503';

import { ThemeContext } from '../context/ThemeContext';
import Deflayout from './layouts/nav/Deflayout';
import BoxIndex from './components/FileManager/BoxIndex';
import JobHazar from './components/Forms/JhaForm/JobHazar';
import TravelForm from './components/Forms/TravelForm/TravelForm';
import FormIndex from './components/Forms';
import JHAJobs from './components/Settings/JHAJobs';
import JobDetails from './components/Settings/JHAJobs/JobDetails';
import JobForm from './components/Settings/JHAJobs/JobForm';
import VoucherForm from './components/Forms/VoucherForm/VoucherForm';
import AppProfile from './components/AppProfile/AppProfile';
import ListProjectCodes from './components/Settings/ProjectCodes/ListProjectCodes';
import AddProjectCode from './components/Settings/ProjectCodes/AddProjectCode';
import ListAccountCode from './components/Settings/AccountCodes/AccountCodeList';
import ViewAccountCode from './components/Settings/AccountCodes/AccountCodeView';
import EditAccountCode from './components/Settings/AccountCodes/AccountCodeEdit';
import AddAccountCode from './components/Settings/AccountCodes/AccounCodeAdd';
import EditProjectCode from './components/Settings/ProjectCodes/EditProjectCode';
import ViewProjectCode from './components/Settings/ProjectCodes/ViewProjectCode';
import AddRoleForm from './components/Settings/Roles/AddRole';
import RoleList from './components/Settings/Roles/ListRole';
import EditRole from './components/Settings/Roles/EditRole';
import ListModuleToRole from './components/Settings/ModuleToRole/ListModuleToRole';
import AddModuleToRole from './components/Settings/ModuleToRole/AddModuleToRole';
import EditModuleToRole from './components/Settings/ModuleToRole/EditModuleToRole';
import ProtectedRoute from '../context/ProtectedRoute';
import FacilityBuildingRoomList from './components/Settings/FacilityBuildingRoom/FacilityBuildingRoomList';
import AddFacilityBuildingRoom from './components/Settings/FacilityBuildingRoom/AddFacilityBuildingRoom';
import UpdateFacilityBuildingRoom from './components/Settings/FacilityBuildingRoom/UpdateFacilityBuildingRoom';
import BoxFolderOfEmpList from './components/Settings/BoxFolderOfEmps/BoxFolderOfEmpList';
import AddBoxFolderOfEmp from './components/Settings/BoxFolderOfEmps/AddBoxFolderOfEmp';
import UpdateBoxFolderOfEmp from './components/Settings/BoxFolderOfEmps/UpdateBoxFolderOfEmp';
import MTEList from './components/Settings/MTE/MTEList';
import AddMTE from './components/Settings/MTE/AddMTE';
import UpdateMTE from './components/Settings/MTE/UpdateMTE';
import JobHazarEdit from './components/Forms/JhaForm/JobHazarEdit';
import { oktaAuth } from '../services/AuthService';
import VoucherFormEdit from './components/Forms/VoucherForm/VoucherFormEdit';
import UserList from './components/Settings/Users/ListUser';
import AddUser from './components/Settings/Users/AddUser';
import EditUser from './components/Settings/Users/EditUser';
import InviteExternalUser from './components/Settings/Users/InviteExternalUser';

import TravelFormEdit from './components/Forms/TravelForm/TravelFormEdit';
import AwardForm from './components/Forms/AwardForm/AwardForm';
import AwardFormEdit from './components/Forms/AwardForm/AwardFormEdit';
import AeaForm from './components/Forms/AEAForm/AeaForm';
import AeaFormEdit from './components/Forms/AEAForm/AeaFormEdit';
import TrainingForm from './components/Forms/TrainingForm/TrainingForm';
import TrainingFormEdit from './components/Forms/TrainingForm/TrainingFormEdit';
import COIForm from './components/Forms/COIForm/COIForm';
import AwardtypeList from './components/Settings/Awardtype/ListAwardtype';
import AddAwardtypeForm from './components/Settings/Awardtype/AddAwardtype';
import EditAwardtype from './components/Settings/Awardtype/EditAwardtype';
import AddTaskNumber from './components/Settings/TaskNumber/AddTaskNumber';
import EditTaskNumber from './components/Settings/TaskNumber/EditTaskNumber';
import ListTaskNumbers from './components/Settings/TaskNumber/ListTaskNumber';
import AddAwardceremonyForm from './components/Settings/Awardceremony/AddAwardceremony';
import EditAwardceremonyForm from './components/Settings/Awardceremony/EditAwardceremony';
import AwardceremonyList from './components/Settings/Awardceremony/ListAwardceremony';
import AwardhistoryList from './components/Settings/Awardhistory/ListAwardhistory';
import AddAwardhistoryForm from './components/Settings/Awardhistory/AddAwardhistory';
import EditAwardhistoryForm from './components/Settings/Awardhistory/EditAwardhistory';
import RequisitionForm from './components/Forms/RequisitionForm/RequisitionForm';
import TuitionHistoryList from './components/Settings/TuitionHistory/ListTuitionHistory';
import AddTuitionForm from './components/Settings/TuitionHistory/AddTuitionHistory';
import EditTuitionForm from './components/Settings/TuitionHistory/EditTuitionHistory';
import SettingsIndex from './components/Settings';
import { useAuth } from '../context/authContext';
import UpdateCourseType from './components/Settings/CourseType/UpdateCourseType';
import AddCourseType from './components/Settings/CourseType/AddCourseType';
import CourseTypeList from './components/Settings/CourseType/CourseTypeList';
import AddCategory from './components/Settings/Category/AddCategory';
import CategoryList from './components/Settings/Category/ListCategory';
import ExpertiseList from './components/Settings/Expertise/ListExpertise';
import COIReport from './components/Reports/COIReport';
import AddExpertise from './components/Settings/Expertise/AddExpertise';
import SkillList from './components/Settings/Skill/ListSkill';
import AddSkill from './components/Settings/Skill/AddSkill';
import EmployeeSkillForm from './components/Forms/EmployeeSkills/AddEmployeeSkill';
import SkillsDashboard from './components/Forms/EmployeeSkills/SkillsDashboard';
import TraininghistoryList from './components/Settings/Traininghistory/ListTraininghistory';
import AddTraininghistory from './components/Settings/Traininghistory/AddTraininghistory';
import EditTraininghistory from './components/Settings/Traininghistory/EditTraininghistory';
import AddJobType from './components/Settings/JobType/AddJobType';
import UpdateJobType from './components/Settings/JobType/UpdateJobType';
import JobTypeList from './components/Settings/JobType/JobTypeList';
import JobTitleList from './components/Settings/JobTitle/JobTitleList';
import AddJobTitle from './components/Settings/JobTitle/AddJobTitle';
import UpdateJobTitle from './components/Settings/JobTitle/UpdateJobTitle';
import OfferRequest from './components/Forms/OfferForm/OfferRequest';
import MCFTForm from './components/Forms/MCFTForm/MCFTForm';
import EWWForm from './components/Forms/EWWForm/EWWForm';
import SHSForm from './components/Forms/SHSForm/ShsForm';
import SubcontractorList from './components/Settings/Subcontractor/SubcontractorList';
import AddSubcontractor from './components/Settings/Subcontractor/AddSubcontractor';
import UpdateSubcontractor from './components/Settings/Subcontractor/UpdateSubcontractor';
import FSRForm from './components/Forms/FSRForm/FSRForm';

const Markup = () => {
  const allroutes = [
    { url: 'dashboard', component: <Home /> },
    { url: 'box-explorer', component: <BoxIndex /> },
    {
      url: 'jha-form',
      component: <JobHazar />,
      isProtected: true,
      module: 'jha-form',
      operations: ['submit'],
    },
    {
      url: 'jha-form/:id',
      component: <JobHazarEdit />,
      isProtected: true,
      module: 'jha-form',
      operations: ['edit'],
    },
    {
      url: 'voucher-form',
      component: <VoucherForm />,
      isProtected: true,
      module: 'voucher-form',
      operations: ['submit'],
    },
    {
      url: 'voucher-form/:id',
      component: <VoucherFormEdit />,
      isProtected: true,
      module: 'voucher-form',
      operations: ['edit'],
    },
    {
      url: 'tripreport-form',
      component: <TravelForm />,
      isProtected: true,
      module: 'tripreport-form',
      operations: ['submit'],
    },
    {
      url: 'tripreport-form/:id',
      component: <TravelFormEdit />,
      isProtected: true,
      module: 'tripreport-form',
      operations: ['edit'],
    },
    {
      url: 'award-form',
      component: <AwardForm />,
      isProtected: true,
      module: 'award-form',
      operations: ['submit'],
    },
    {
      url: 'award-form/:id',
      component: <AwardFormEdit />,
      isProtected: true,
      module: 'award-form',
      operations: ['edit'],
    },
    {
      url: 'aea-form',
      component: <AeaForm />,
      isProtected: true,
      module: 'aea-form',
      operations: ['submit'],
    },
    {
      url: 'aea-form/:id',
      component: <AeaFormEdit />,
      isProtected: true,
      module: 'aea-form',
      operations: ['edit'],
    },
    {
      url: 'training-form',
      component: <TrainingForm />,
      isProtected: true,
      module: 'training-form',
      operations: ['submit'],
    },
    {
      url: 'training-form/:id',
      component: <TrainingFormEdit />,
      isProtected: true,
      module: 'training-form',
      operations: ['edit'],
    },
    {
      url: 'coi-form',
      component: <COIForm />,
      isProtected: true,
      module: 'coi-form',
      operations: ['submit'],
    },
    {
      url: 'requisition-form',
      component: <RequisitionForm />,
      isProtected: true,
      module: 'requisition-form',
      operations: ['submit'],
    },
    {
      url: 'skills-form',
      component: <EmployeeSkillForm />,
      isProtected: true,
      module: 'skills-form',
      operations: ['submit'],
    },
    {
      url: 'skills-dashboard',
      component: <SkillsDashboard />,
      isProtected: true,
      module: 'skills-dashboard',
      operations: ['read'],
    },

    {
      url: 'offer-form',
      component: <OfferRequest />,
      isProtected: true,
      module: 'offer-form',
      operations: ['read'],
    },

    {
      url: 'mcft-form',
      component: <MCFTForm />,
      isProtected: true,
      module: 'mcft-form',
      operations: ['read'],
    },

    {
      url: 'eww-form',
      component: <EWWForm />,
      isProtected: true,
      module: 'eww-form',
      operations: ['read'],
    },

    {
      url: 'shs-form',
      component: <SHSForm />,
      isProtected: true,
      module: 'shs-form',
      operations: ['read'],
    },

    {
      url: 'fsr-form',
      component: <FSRForm />,
      isProtected: true,
      module: 'fsr-form',
      operations: ['read'],
    },

    {
      url: 'coi-report',
      component: <COIReport />,
      isProtected: true,
      module: 'coi-report',
      operations: ['read'],
    },

    { url: 'profile', component: <AppProfile /> },
    { url: 'empty', component: <EmptyPage /> },
    { url: 'forms', component: <FormIndex /> },
    { url: 'settings', component: <SettingsIndex /> },
    {
      url: 'settings/jha-setting/',
      component: <JHAJobs />,
      isProtected: true,
      module: 'jha-job-settings',
      operations: ['read'],
    },
    {
      url: 'settings/jha-setting/add',
      component: <JobForm />,
      isProtected: true,
      module: 'jha-job-settings',
      operations: ['write'],
    },
    {
      url: 'settings/jha-setting/view',
      component: <JobDetails />,
      isProtected: true,
      module: 'jha-job-settings',
      operations: ['read'],
    },
    {
      url: 'settings/jha-setting/edit',
      component: <JobForm />,
      isProtected: true,
      module: 'jha-job-settings',
      operations: ['edit'],
    },

    {
      url: 'settings/project-code',
      component: <ListProjectCodes />,
      isProtected: true,
      module: 'project-code-settings',
      operations: ['read'],
    },
    {
      url: 'settings/project-code/add',
      component: <AddProjectCode />,
      isProtected: true,
      module: 'project-code-settings',
      operations: ['write'],
    },
    {
      url: 'settings/project-code/view/:id',
      component: <ViewProjectCode />,
      isProtected: true,
      module: 'project-code-settings',
      operations: ['read'],
    },
    {
      url: 'settings/project-code/edit/:id',
      component: <EditProjectCode />,
      isProtected: true,
      module: 'project-code-settings',
      operations: ['edit'],
    },

    {
      url: 'settings/account-code',
      component: <ListAccountCode />,
      isProtected: true,
      module: 'account-code-settings',
      operations: ['read'],
    },
    {
      url: 'settings/account-code/add',
      component: <AddAccountCode />,
      isProtected: true,
      module: 'account-code-settings',
      operations: ['write'],
    },
    {
      url: 'settings/account-code/view/:id',
      component: <ViewAccountCode />,
      isProtected: true,
      module: 'account-code-settings',
      operations: ['read'],
    },
    {
      url: 'settings/account-code/edit/:id',
      component: <EditAccountCode />,
      isProtected: true,
      module: 'account-code-settings',
      operations: ['edit'],
    },

    {
      url: 'settings/roles',
      component: <RoleList />,
      isProtected: true,
      module: 'roles-settings',
      operations: ['read'],
    },
    {
      url: 'settings/roles/add',
      component: <AddRoleForm />,
      isProtected: true,
      module: 'roles-settings',
      operations: ['write'],
    },
    {
      url: 'settings/roles/edit/:id',
      component: <EditRole />,
      isProtected: true,
      module: 'roles-settings',
      operations: ['edit'],
    },

    {
      url: 'settings/mtr',
      component: <ListModuleToRole />,
      isProtected: true,
      module: 'mtr-settings',
      operations: ['read'],
    },
    {
      url: 'settings/mtr/add',
      component: <AddModuleToRole />,
      isProtected: true,
      module: 'mtr-settings',
      operations: ['write'],
    },
    {
      url: 'settings/mtr/edit/:id',
      component: <EditModuleToRole />,
      isProtected: true,
      module: 'mtr-settings',
      operations: ['edit'],
    },

    {
      url: 'settings/fbr',
      component: <FacilityBuildingRoomList />,
      isProtected: true,
      module: 'fbr-settings',
      operations: ['read'],
    },
    {
      url: 'settings/fbr/add',
      component: <AddFacilityBuildingRoom />,
      isProtected: true,
      module: 'fbr-settings',
      operations: ['write'],
    },
    {
      url: 'settings/fbr/edit/:id',
      component: <UpdateFacilityBuildingRoom />,
      isProtected: true,
      module: 'fbr-settings',
      operations: ['edit'],
    },

    {
      url: 'settings/box-folders',
      component: <BoxFolderOfEmpList />,
      isProtected: true,
      module: 'box-folders-settings',
      operations: ['read'],
    },
    {
      url: 'settings/box-folders/add',
      component: <AddBoxFolderOfEmp />,
      isProtected: true,
      module: 'box-folders-settings',
      operations: ['write'],
    },
    {
      url: 'settings/box-folders/edit/:id',
      component: <UpdateBoxFolderOfEmp />,
      isProtected: true,
      module: 'box-folders-settings',
      operations: ['edit'],
    },

    {
      url: 'settings/mte',
      component: <MTEList />,
      isProtected: true,
      module: 'mte-settings',
      operations: ['read'],
    },
    {
      url: 'settings/mte/add',
      component: <AddMTE />,
      isProtected: true,
      module: 'mte-settings',
      operations: ['write'],
    },
    {
      url: 'settings/mte/edit/:id',
      component: <UpdateMTE />,
      isProtected: true,
      module: 'mte-settings',
      operations: ['edit'],
    },

    {
      url: 'settings/users',
      component: <UserList />,
      isProtected: true,
      module: 'user-settings',
      operations: ['read'],
    },
    {
      url: 'settings/users/add',
      component: <AddUser />,
      isProtected: true,
      module: 'user-settings',
      operations: ['write'],
    },
    {
      url: 'settings/users/invite-external',
      component: <InviteExternalUser />,
      isProtected: true,
      module: 'user-settings',
      operations: ['write'],
    },
    {
      url: 'settings/users/edit/:id',
      component: <EditUser />,
      isProtected: true,
      module: 'user-settings',
      operations: ['edit'],
    },

    {
      url: 'settings/task-number',
      component: <ListTaskNumbers />,
      isProtected: true,
      module: 'task-number-settings',
      operations: ['read'],
    },
    {
      url: 'settings/task-number/add',
      component: <AddTaskNumber />,
      isProtected: true,
      module: 'task-number-settings',
      operations: ['write'],
    },
    {
      url: 'settings/task-number/edit/:id',
      component: <EditTaskNumber />,
      isProtected: true,
      module: 'task-number-settings',
      operations: ['edit'],
    },

    {
      url: 'settings/awardtypes',
      component: <AwardtypeList />,
      isProtected: true,
      module: 'awardtypes-settings',
      operations: ['read'],
    },
    {
      url: 'settings/awardtypes/add',
      component: <AddAwardtypeForm />,
      isProtected: true,
      module: 'awardtypes-settings',
      operations: ['write'],
    },
    {
      url: 'settings/awardtypes/edit/:id',
      component: <EditAwardtype />,
      isProtected: true,
      module: 'awardtypes-settings',
      operations: ['edit'],
    },

    {
      url: 'settings/awardceremonies',
      component: <AwardceremonyList />,
      isProtected: true,
      module: 'awardceremonies-settings',
      operations: ['read'],
    },
    {
      url: 'settings/awardceremonies/add',
      component: <AddAwardceremonyForm />,
      isProtected: true,
      module: 'awardceremonies-settings',
      operations: ['write'],
    },
    {
      url: 'settings/awardceremonies/edit/:id',
      component: <EditAwardceremonyForm />,
      isProtected: true,
      module: 'awardceremonies-settings',
      operations: ['edit'],
    },

    {
      url: 'settings/awardhistory',
      component: <AwardhistoryList />,
      isProtected: true,
      module: 'awardhistory-settings',
      operations: ['read'],
    },
    {
      url: 'settings/awardhistory/add',
      component: <AddAwardhistoryForm />,
      isProtected: true,
      module: 'awardhistory-settings',
      operations: ['write'],
    },
    {
      url: 'settings/awardhistory/edit/:id',
      component: <EditAwardhistoryForm />,
      isProtected: true,
      module: 'awardhistory-settings',
      operations: ['edit'],
    },

    {
      url: 'settings/traininghistory',
      component: <TraininghistoryList />,
      isProtected: true,
      module: 'training-history-settings',
      operations: ['read'],
    },
    {
      url: 'settings/traininghistory/add',
      component: <AddTraininghistory />,
      isProtected: true,
      module: 'training-history-settings',
      operations: ['write'],
    },
    {
      url: 'settings/traininghistory/edit/:id',
      component: <EditTraininghistory />,
      isProtected: true,
      module: 'training-history-settings',
      operations: ['edit'],
    },

    {
      url: 'settings/tuition',
      component: <TuitionHistoryList />,
      isProtected: true,
      module: 'tuition-settings',
      operations: ['read'],
    },
    {
      url: 'settings/tuition/add',
      component: <AddTuitionForm />,
      isProtected: true,
      module: 'tuition-settings',
      operations: ['write'],
    },
    {
      url: 'settings/tuition/:email/:year',
      component: <EditTuitionForm />,
      isProtected: true,
      module: 'tuition-settings',
      operations: ['edit'],
    },

    {
      url: 'settings/coursetype',
      component: <CourseTypeList />,
      isProtected: true,
      module: 'course-type-settings',
      operations: ['read'],
    },
    {
      url: 'settings/coursetype/add',
      component: <AddCourseType />,
      isProtected: true,
      module: 'course-type-settings',
      operations: ['write'],
    },
    {
      url: 'settings/coursetype/edit/:id',
      component: <UpdateCourseType />,
      isProtected: true,
      module: 'course-type-settings',
      operations: ['edit'],
    },

    {
      url: 'settings/skillcategory',
      component: <CategoryList />,
      isProtected: true,
      module: 'skill-category-settings',
      operations: ['read'],
    },
    {
      url: 'settings/skillcategory/add',
      component: <AddCategory />,
      isProtected: true,
      module: 'skill-category-settings',
      operations: ['write'],
    },
    {
      url: 'settings/skillcategory/edit/:id',
      component: <AddCategory />,
      isProtected: true,
      module: 'skill-category-settings',
      operations: ['edit'],
    },

    {
      url: 'settings/expertise',
      component: <ExpertiseList />,
      isProtected: true,
      module: 'skill-expertise-settings',
      operations: ['read'],
    },
    {
      url: 'settings/expertise/add',
      component: <AddExpertise />,
      isProtected: true,
      module: 'skill-expertise-settings',
      operations: ['write'],
    },
    {
      url: 'settings/expertise/edit/:id',
      component: <AddExpertise />,
      isProtected: true,
      module: 'skill-expertise-settings',
      operations: ['edit'],
    },

    {
      url: 'settings/skills',
      component: <SkillList />,
      isProtected: true,
      module: 'skills-settings',
      operations: ['read'],
    },
    {
      url: 'settings/skills/add',
      component: <AddSkill />,
      isProtected: true,
      module: 'skills-settings',
      operations: ['write'],
    },
    {
      url: 'settings/skills/edit/:id',
      component: <AddSkill />,
      isProtected: true,
      module: 'skills-settings',
      operations: ['edit'],
    },

    {
      url: 'settings/jobtitle',
      component: <JobTitleList />,
      isProtected: true,
      module: 'jobtitle-settings',
      operations: ['read'],
    },
    {
      url: 'settings/jobtitle/add',
      component: <AddJobTitle />,
      isProtected: true,
      module: 'jobtitle-settings',
      operations: ['write'],
    },
    {
      url: 'settings/jobtitle/edit/:id',
      component: <UpdateJobTitle />,
      isProtected: true,
      module: 'jobtitle-settings',
      operations: ['edit'],
    },

    {
      url: 'settings/jobtype',
      component: <JobTypeList />,
      isProtected: true,
      module: 'jobtype-settings',
      operations: ['read'],
    },
    {
      url: 'settings/jobtype/add',
      component: <AddJobType />,
      isProtected: true,
      module: 'jobtype-settings',
      operations: ['write'],
    },
    {
      url: 'settings/jobtype/edit/:id',
      component: <UpdateJobType />,
      isProtected: true,
      module: 'jobtype-settings',
      operations: ['edit'],
    },

    {
      url: 'settings/subcontractor',
      component: <SubcontractorList />,
      isProtected: true,
      module: 'subcontractor-settings',
      operations: ['read'],
    },
    {
      url: 'settings/subcontractor/add',
      component: <AddSubcontractor />,
      isProtected: true,
      module: 'subcontractor-settings',
      operations: ['write'],
    },
    {
      url: 'settings/subcontractor/edit/:id',
      component: <UpdateSubcontractor />,
      isProtected: true,
      module: 'subcontractor-settings',
      operations: ['edit'],
    },
  ];

  function NotFound() {
    const url = allroutes.map((route) => route.url);
    let path = window.location.pathname;
    path = path.split('/');
    path = path[path.length - 1];

    if (url.indexOf(path) <= 0) {
      return <Error404 />;
    }
  }
  return (
    <Suspense
      fallback={
        <div id="preloader">
          <div className="sk-three-bounce">
            <div className="sk-child sk-bounce1"></div>
            <div className="sk-child sk-bounce2"></div>
            <div className="sk-child sk-bounce3"></div>
          </div>
        </div>
      }
    >
      <Routes>
        <Route path="/page-error-400" element={<Error400 />} />

        <Route path="/page-error-404" element={<Error404 />} />
        <Route path="/page-error-500" element={<Error500 />} />
        <Route path="/page-error-503" element={<Error503 />} />

        <Route element={<MainLayout />}>
          {allroutes.map((data, i) => {
            if (data.isProtected == true) {
              return (
                <Route
                  key={i}
                  exact
                  path={`${data.url}`}
                  element={
                    <ProtectedRoute
                      element={data.component}
                      module={data.module}
                      operations={data.operations}
                    />
                  }
                />
              );
            } else {
              return <Route key={i} exact path={`${data.url}`} element={data.component} />;
            }
          })}
          <Route path="/unauthorized" element={<Error403 />} />
        </Route>
        {/* <Route path='*' element={<NotFound/>} />                  */}
      </Routes>
      <ScrollToTop />
    </Suspense>
  );
};

function MainLayout() {
  const { sidebariconHover } = useContext(ThemeContext);
  const sideMenu = useSelector((state) => state.sideMenu);
  const { user } = useAuth();
  return (
    user && (
      <div
        id="main-wrapper"
        className={`show ${sidebariconHover ? 'iconhover-toggle' : ''} ${
          sideMenu ? 'menu-toggle' : ''
        }`}
      >
        <Deflayout />
        <div className="content-body">
          <div className="container-fluid" style={{ minHeight: window.screen.height - 45 }}>
            <Outlet />
          </div>
        </div>
        <Footer />
      </div>
    )
  );
}

export default Markup;
